// @ts-nocheck
import { GOOGLE_MAPS_PACKAGE_ON_LOAD } from "../constants/googleMapsPackageConstants";

const initialValues = {
	isLoaded: false,
	loadError: false
};

const googleMapsReducer = (state = initialValues, action) => {
  switch (action.type) {

		case GOOGLE_MAPS_PACKAGE_ON_LOAD:
			return {
				...state,
				isLoaded: action?.payload?.isLoaded,
				loadError: action?.payload?.loadError
			}

    default:
      return state;
  }
};

export default googleMapsReducer;
export {
	initialValues
}